import { useQuery } from '@tcs/common/hooks/useQuery';
import { AccountProfile } from '@tcs/client-portal-api/src/types/AccountProfile';

interface Props {
  isLoading: boolean;
  data?: AccountProfile;
}

export const useProfile = (
  accountNumber: string,
  options?: { enabled?: boolean }
): Props => {
  const { data, isLoading } = useQuery<AccountProfile, Error>(
    `/accounts/${accountNumber}/profile`,
    options
  );
  return {
    isLoading,
    data,
  };
};

export default useProfile;
